import { haptic } from '../telegram'

/**
 * Плитка периода: подпись сверху, крупное название, пояснение и тонкая полоса
 * снизу — сколько периода уже прошло. Полоса именно тонкая: это не индикатор
 * загрузки, а положение в цикле.
 */
export function Tile({
  label,
  title,
  note,
  progress,
  color = 'var(--gold)',
  onClick,
}: {
  label: string
  title: string
  note?: string
  progress?: number
  color?: string
  onClick?: () => void
}) {
  const share = progress === undefined ? null : Math.min(1, Math.max(0, progress))
  return (
    <button
      type="button"
      className="tile"
      disabled={!onClick}
      onClick={() => {
        if (!onClick) return
        haptic('light')
        onClick()
      }}
    >
      <span className="lbl" style={{ color }}>
        {label}
      </span>
      <span className="tile-title">{title}</span>
      {note && <span className="tile-note">{note}</span>}
      {share !== null && (
        <span className="tile-bar">
          <span className="tile-fill" style={{ width: `${Math.round(share * 100)}%`, background: color }} />
        </span>
      )}
    </button>
  )
}
